import { css } from 'styled-components';
import { theme } from 'types';

export const gridRowCenter = css`
    display: grid;
    place-items: center;
    align-content: center;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    grid-auto-columns: 100%;
    width: 100%;
    gap: 1rem;
`;
export const gridColumnCenter = css`
    display: grid;
    place-items: center;
    align-content: center;
    grid-auto-flow: column;
    grid-auto-rows: max-content;
    grid-auto-columns: max-content;
    width: 100%;
    gap: 1rem;
`;

export const flexCenter = css`
    display: flex;
    place-items: center;
    align-items: center;
    justify-content: center;
`;

const gapOption = css<theme.TGapOption>`
    gap: ${({ gap }) => (gap ? `${gap}rem` : `1rem`)};
`;

const gridJustifyAlign = css<theme.TGridJustifyAlign>`
    display: grid;

    ${({ align = 'center' }) => {
        switch (align) {
            default:
            case 'center':
                return css`
                    align-items: center;
                    align-content: center;
                `;
            case 'top':
                return css`
                    align-items: flex-start;
                    align-content: flex-start;
                `;
            case 'bottom':
                return css`
                    align-items: flex-end;
                    align-content: flex-end;
                `;
        }
    }}

    ${({ justify = 'center' }) => {
        switch (justify) {
            default:
            case 'center':
                return css`
                    justify-content: center;
                    justify-items: center;
                `;
            case 'start':
                return css`
                    justify-content: flex-start;
                    justify-items: flex-start;
                `;
            case 'end':
                return css`
                    justify-content: flex-end;
                    justify-items: flex-end;
                `;
        }
    }}
`;

const afterPseudoOption = css`
    position: relative;
    &::after {
        content: ' ';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
    }
`;

const mixins = {
    gridJustifyAlign,
    gridRowCenter,
    flexCenter,
    gridColumnCenter,
    gapOption,
    afterPseudoOption,
};

export default mixins;
